import Home from "../pages/Home";
import OurServices from "../pages/OurServicesPage";
import ServiceDetails from "../pages/ServiceDetailsPage";
import Careers from "../pages/Careers";
import JoinUs from "../pages/JoinUs";
import TeamActivity from "../pages/TeamActivity";
import CaseStudiesDetails from "../pages/CaseStudyDetails";
import CaseStudies from "../pages/CaseStudiesPage";
import AboutUs from "../pages/AboutUs";
import OurCulture from "../pages/OurCulture";
import  Contact  from "../pages/Contact";
import PartnershipsCollaborations from "../pages/PartnershipsCollaborations";
import TeamActivityDetails from "../pages/TeamActivityDetails";
import JobOpening from "../pages/JobOpening";
import JobDetails from '../pages/JobDetails';
import Internship from "../pages/Internship";
import SkillDevelopment from "../pages/SkillDevelopment";
import CourseDetails from "../pages/CourseDetails";
import TechnologyDetails from "../pages/TechnolohyDetails";
import LoginRegister from "../pages/LoginRegister";
import ProductDetails from "../pages/ProductDetails";
import Blogs from "../pages/Blogs";
import ClientPartner from "../pages/ClientPartner";
import BlogDetails from "../pages/BlogDetails";
import Leaders from "../pages/Leaders";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import NotFoundPage from "../pages/NotFoundPage";

// Card Components
import IDCardPage from "../id_vc/components/IDCardPage";
import VisitingCardPage from "../id_vc/components/VisitingCardPage";

// Service Detail Pages
import APIIntegrationPage from "../pages/ServiceDetailsPages/APIIntegrationPage";
import ETLDataWarehousePage from "../pages/ServiceDetailsPages/ETLDataWarehousePage";
import ManagedServicesPage from "../pages/ServiceDetailsPages/ManagedServicesPage";
import CustomizedSoftwareDevelopmentPage from "../pages/ServiceDetailsPages/CustomizedSoftwareDevelopmentPage";
import CustomizedMobileAppDevelopmentPage from "../pages/ServiceDetailsPages/CustomizedMobileAppDevelopmentPage";
import RecordDigitizationServicesPage from "../pages/ServiceDetailsPages/RecordDigitizationServicesPage";
import TechSupportServicesPage from "../pages/ServiceDetailsPages/TechSupportServicesPage";
import DevOpsServicesPage from "../pages/ServiceDetailsPages/DevOpsServicesPage";
import ApplicationMigrationServicesPage from "../pages/ServiceDetailsPages/ApplicationMigrationServicesPage";
import AIDrivenCybersecurityServicesPage from "../pages/ServiceDetailsPages/AIDrivenCybersecurityServicesPage";

// Product Detail Pages
import OSSPPage from "../pages/ProductDetails/OSSPPage";
import QueueProPage from "../pages/ProductDetails/QueueProPage";
import EBSPage from "../pages/ProductDetails/EBSPage";
import InsightDBPage from "../pages/ProductDetails/InsightDBPage";
import SmartDeliveryPlatformPage from "../pages/ProductDetails/SmartDeliveryPlatformPage";
import DigitalCorporateBankingPage from "../pages/ProductDetails/DigitalCorporateBankingPage";

const routes = [
  // Public routes
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/our-services",
    element: <OurServices />,
  },
  {
    path: "/our-services/:id",
    element: <ServiceDetails />,
  },
  // Individual Service Detail Pages
  {
    path: "/services/api-integration",
    element: <APIIntegrationPage />,
  },
  {
    path: "/services/etl-data-warehouse",
    element: <ETLDataWarehousePage />,
  },
  {
    path: "/services/managed-services",
    element: <ManagedServicesPage />,
  },
  {
    path: "/services/customized-software-development",
    element: <CustomizedSoftwareDevelopmentPage />,
  },
  {
    path: "/services/customized-mobile-app-development",
    element: <CustomizedMobileAppDevelopmentPage />,
  },
  {
    path: "/services/record-digitization-services",
    element: <RecordDigitizationServicesPage />,
  },
  {
    path: "/services/tech-support-services",
    element: <TechSupportServicesPage />,
  },
  {
    path: "/services/devops-services",
    element: <DevOpsServicesPage />,
  },
  {
    path: "/services/application-migration-services",
    element: <ApplicationMigrationServicesPage />,
  },
  {
    path: "/services/ai-driven-cybersecurity-services",
    element: <AIDrivenCybersecurityServicesPage />,
  },
  {
    path: "/careers",
    element: <Careers />,
  },
  {
    path: "/join-us",
    element: <JoinUs />,
  },
  {
    path: "/team-activity",
    element: <TeamActivity />,
  },
  {
    path: "/case-studies/:slug",
    element: <CaseStudiesDetails />,
  },
  {
    path: "/case-studies",
    element: <CaseStudies />,
  },
  {
    path: "/about-us",
    element: <AboutUs />,
  },
  {
    path: "/leaders",
    element: <Leaders />,
  },
  {
    path: "/our-culture",
    element: <OurCulture />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/partnerships-collaborations",
    element: <PartnershipsCollaborations />,
  },
  {
    path: "/team-activity/:id",
    element: <TeamActivityDetails />,
  },
  {
    path: "/job-opening",
    element: <JobOpening />,
  },
  {
    path: '/job-details/:id',
    element: <JobDetails />,
  },
  {
    path: '/internship',
    element: <Internship />,
  },
  {
    path: '/skill-development',
    element: <SkillDevelopment />,
  },
  {
    path: '/course-details/:id',
    element: <CourseDetails />,
  },
  {
    path: '/technology-details/:id',
    element: <TechnologyDetails />,
  },
  {
    path: '/technology/:slug',
    element: <TechnologyDetails />,
  },
  {
    path: '/login-register',
    element: <LoginRegister />,
  },
  // Individual Product Detail Pages
  {
    path: '/products/ossp',
    element: <OSSPPage />,
  },
  {
    path: '/products/queuepro',
    element: <QueueProPage />,
  },
  {
    path: '/products/ebs',
    element: <EBSPage />,
  },
  {
    path: '/products/insightdb',
    element: <InsightDBPage />,
  },
  {
    path: '/products/smart-delivery-platform',
    element: <SmartDeliveryPlatformPage />,
  },
  // {
  //   path: '/products/digital-corporate-banking',
  //   element: <DigitalCorporateBankingPage />,
  // },
  // Generic Product Details Route (for API-driven products)
  {
    path: '/product-details/:id',
    element: <ProductDetails />,
  },
  {
    path: '/newsroom',
    element: <Blogs />,
  },
  {
    path: '/client-partner',
    element: <ClientPartner />,
  },
  {
    path: '/newsroom-details/:id',
    element: <BlogDetails />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicy />,
  },
  // Card Routes
  {
    path: '/vc/:email',
    element: <VisitingCardPage />,
  },
  {
    path: '/idCard/:email',
    element: <IDCardPage />,
  },
  // Catch-all route - must be last
  // This will match any unmatched routes and show a proper 404 page
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
